import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box, FormControlLabel, FormHelperText } from '@material-ui/core'

import { PropFilter } from './PropFilter'

import { WbProductsTableProps } from './WbProductsTable'

import { emDash } from '../common/stringUtility'

export type WbProductsTrashedFilterProps =
  Pick<WbProductsTableProps, 'products'>

export const WbProductsTrashedFilter =
  observer(
    ({products}: WbProductsTrashedFilterProps) =>
      <>
        <FormControlLabel
          labelPlacement="start"
          label={<span style={{fontSize: '12px'}}>В корзине WB</span>}
          control={
            <Box marginLeft={1}>
              <PropFilter
                filter={{
                  isBoolean: true,
                  placeholder: emDash,
                  onText: 'да',
                  offText: 'нет',
                  value: products.findPropFilterValue('isTrashed'),
                  setValue: _ => products.setPropFilter('isTrashed', _),
                  readOnly: products.getPropFilterReadOnly('isTrashed')
                }}
              />
            </Box>}
        />

        <FormHelperText>&nbsp;{/*spacer*/}</FormHelperText>
      </>)